import API from "@/common/API";
import { FormatMoney } from "@/common/helpers";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import type { ChartOptions } from "chart.js";
const Summary = (props) => {
    const { t } = useTranslation("global");
    const [record, setRecord] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [amountChartData, setAmountChartData] = useState(null);

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend
    );


    const chartOptions: ChartOptions<"bar"> = {
        responsive: true,
        plugins: {
            legend: { position: "top" },
            title: {
                display: true,
                text: t("Invoices and Quotes per Month"),
            },
        },
    };
    const chartAmountOptions: ChartOptions<"bar"> = {
        responsive: true,
        plugins: {
            legend: { position: "top" },
            title: {
                display: true,
                text: t("Invoices and Quotes Amount per Month"),
            },
        },
    };
    const buildMonthlyChart = (records) => {
        const labels = records.map(item => item.monthLabel || item.MonthLabel || "");
        const invoiceCounts = records.map(item => item.invoices ?? item.Invoices ?? 0);
        const quoteCounts = records.map(item => item.quotes ?? item.Quotes ?? 0);

        setChartData({
            labels,
            datasets: [
                {
                    label: t("Invoices"),
                    data: invoiceCounts,
                    backgroundColor: "rgba(59, 130, 246, 0.6)",
                },
                {
                    label: t("Quotes"),
                    data: quoteCounts,
                    backgroundColor: "rgba(234, 88, 12, 0.6)",
                },
            ],
        });
    };
    const buildAmountMonthlyChart = (records) => {
        const labels = records.map(item => item.monthLabel || item.MonthLabel || "");
        const invoiceAmounts = records.map(item => item.invoices ?? item.Invoices ?? 0);
        const quoteAmounts = records.map(item => item.quotes ?? item.Quotes ?? 0);

        setAmountChartData({
            labels,
            datasets: [
                {
                    label: t("Invoices"),
                    data: invoiceAmounts,
                    backgroundColor: "rgba(59, 130, 246, 0.6)",
                },
                {
                    label: t("Quotes"),
                    data: quoteAmounts,
                    backgroundColor: "rgba(234, 88, 12, 0.6)",
                },
            ],
        });
    };

    const bindData = async () => {
        try {
            const [summaryRequest, monthlyRequest, amountMonthlyRequest] = await Promise.all([
                API.getAction(`placeDashboard/summary?id=${props.model.id}`),
                API.getAction(`placeDashboard/InvoicesQuotesMonthly?id=${props.model.id}`),
                API.getAction(`placeDashboard/AmountInvoicesQuotesMonthly?id=${props.model.id}`),
            ]);

            if (summaryRequest.status === 200) {
                setRecord(summaryRequest.data.response);
            }

            const monthlyRecords = monthlyRequest.status === 200 ? monthlyRequest.data.response || [] : [];
            const amountMonthlyRecords = amountMonthlyRequest.status === 200 ? amountMonthlyRequest.data.response || [] : [];
            buildMonthlyChart(monthlyRecords);
            buildAmountMonthlyChart(amountMonthlyRecords);
        } catch (e) {
            // Error handled
        }
    }
    useEffect(() => {
        if (props?.model?.id) {
            bindData();
        }
    }, [props?.model?.id]);
    return <div className="mb-4">
        <Row>
            {record?.ochoaInfo && <>
                {/* <Col xs={12}>
                    <h2 className="display-4 mt-4">{t("Ochoa")}</h2>
                    <hr />
                </Col> */}
                <Col xs={6} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>RD$ {FormatMoney(record?.totalInvoiced || 0)}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Total Invoices")}
                        </Card.Footer>
                    </Card>
                </Col>
                <Col xs={6} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>RD$ {FormatMoney(record?.totalQuoted || 0)}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Total Quotations")}
                        </Card.Footer>
                    </Card>
                </Col>
                <Col xs={6} md={4} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>{record?.amountOfQuotes || 0}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Amount of Quotes")}
                        </Card.Footer>
                    </Card>
                </Col>
                <Col xs={6} md={4} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>{record?.amountOfInvoices || 0}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Amount of Invoices")}
                        </Card.Footer>
                    </Card>
                </Col>
                <Col xs={6} md={4} className="mb-2">
                    <Card className="shadow-sm">
                        <Card.Body className="py-2">
                            <h3>{record?.totalQuotedNotInvoiced || 0}</h3>
                        </Card.Body>
                        <Card.Footer className="py-2">
                            {t("Quotes without invoices")}
                        </Card.Footer>
                    </Card>
                </Col>
                {amountChartData && (
                    <Col xs={12} className="mb-3">
                        <Card className="shadow-sm">
                            <Card.Body>
                                <Bar options={chartAmountOptions} data={amountChartData} />
                            </Card.Body>
                        </Card>
                    </Col>
                )}
                {chartData && (
                    <Col xs={12} className="mb-3">
                        <Card className="shadow-sm">
                            <Card.Body>
                                <Bar options={chartOptions} data={chartData} />
                            </Card.Body>
                        </Card>
                    </Col>
                )}


            </>}

            {/* <Col xs={12}>
                <h2 className="display-4 mt-4">{t("Shearly BI")}</h2>
                <hr />
            </Col> */}
            <Col xs={6} md={4} className="mb-2">
                <Card className="shadow-sm">
                    <Card.Body className="py-2">
                        <h3>{record?.totalVisits || 0}</h3>
                    </Card.Body>
                    <Card.Footer className="py-2">
                        {t("Total Visits")}
                    </Card.Footer>
                </Card>
            </Col>
            <Col xs={6} md={4} className="mb-2">
                <Card className="shadow-sm">
                    <Card.Body className="py-2">
                        <h3>{record?.totalDispatchVisits || 0}</h3>
                    </Card.Body>
                    <Card.Footer className="py-2">
                        {t("Total Dispatched Visits")}
                    </Card.Footer>
                </Card>
            </Col>
        </Row>
    </div>;
};

export default Summary;